<template>
  <div>
    <el-form
      class="login-form form-custom"
      :class="{ 'mgb-reset': !isIndex }"
      ref="form"
      label-position="top"
      label-width="80px"
      @submit.native.prevent
      @keyup.enter.native="next"
      :hide-required-asterisk="true"
      :rules="rules"
      :model="form"
    >
      <el-form-item class="form-item-primary" prop="phone">
        <!-- 电话 -->
        <BaseInput
          v-model="form.phone"
          :autofocus="!isMobile"
          @blur="setAccount(form.phone)"
          :validate-event="Boolean(form.phone)"
          :placeholer="$t('login.loginPage.phoneNumber')"
          :maxLength="11"
        >
          <template #prepend>
            <el-select v-model="form.pretel" style="width: 100px" disabled>
              <el-option
                v-for="item in preTelList"
                :value="item"
                :label="'+' + item"
                :key="'+' + item.toString()"
                >+ {{ item }}</el-option
              >
            </el-select>
          </template>
        </BaseInput>
      </el-form-item>
    </el-form>
    <el-button
      class="button-custom"
      @click="next"
      v-track="{
        type: 'click',
        name: `${$route.params.type || 'phone'}.${
          $route.params.step || 'account'
        }.continue`,
      }"
      >{{ $t('login.loginPage.continue') }}</el-button
    >
    <!-- <BaseLine :text="$t('login.register.or')" /> -->
    <OtherLogin />
  </div>
</template>
<script>
import BaseInput from '@/components/common/BaseInput.vue'
// import BaseLine from '@/components/common/BaseLine'
import OtherLogin from '@/components/login/OtherLogin'
import BaseMixin from '@/mixins/BaseMixin'
import AccountMixins from '@/mixins/AccountMixins.js'
import LoginStepAccountMixin from '../mixins/LoginStepAccountMixin'
import store from '@/store'
export default {
  components: {
    BaseInput,
    // BaseLine,
    OtherLogin,
  },
  mixins: [BaseMixin, AccountMixins, LoginStepAccountMixin],
  props: {},
  data() {
    return {
      form: {
        phone: '',
      },
      submitDisabled: false,
    }
  },
  computed: {
    rules() {
      return {
        phone: [
          {
            required: true,
            message: this.$t('login.register.labelRegisteredPhone'),
          },
          {
            validator: async (rule, value, callback) => {
              let reg = /^(?:(?:\+|00)86)?1\d{10}$/
              if (reg.test(value)) {
                try {
                  let { data } = await store.dispatch('CheckUser', {
                    user_name: value,
                  })
                  if (data) {
                    // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                    this.registered = false
                    return callback(
                      new Error(this.$t('login.register.notExists'))
                    )
                  } else {
                    // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                    this.registered = true
                    return callback()
                  }
                } catch (error) {
                  return callback()
                }
              }
              return callback(
                new Error(
                  // TODO: 手机号码错误提示
                  this.$t('login.resetPassword.validPhone')
                )
              )
            },
            trigger: 'blur',
          },
        ],
      }
    },
  },
  watch: {
    'form.phone': {
      handler: function (newVal) {
        this.submitDisabled = !newVal
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {},
}
</script>
<style lang="scss" scoped></style>
